import { render } from "./EditRegister.vue?vue&type=template&id=337dca05&scoped=true"
import script from "./EditRegister.vue?vue&type=script&lang=js"
export * from "./EditRegister.vue?vue&type=script&lang=js"

import "./EditRegister.vue?vue&type=style&index=0&id=337dca05&lang=scss&scoped=true"
import "./EditRegister.vue?vue&type=style&index=1&id=337dca05&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337dca05"]])

export default __exports__